import React from 'react';

const Card = ({children,addClass=""}) => {
    return (
        <div className={`card carder ${addClass} `}>
            {children}
        </div>
    );
};

export default Card;